import { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import { LoadingScreen } from "./LoadingScreen";
import { useTranslation } from "react-i18next";
import { Error409 } from "../pages/errors/error409";
import i18n from "../i18n";

export const Logout = () => {

    const { t } = useTranslation(); // Multi Language

    const auth = useAuth();
    const [isLoading, setIsLoading] = useState<boolean | null>(null)

    useEffect(() => {
        if (auth?.isAuthenticated) {
            setIsLoading(true)
            auth.signoutRedirect({
                extraQueryParams: {
                    kc_locale: i18n.language
                }
            })
        }
        return () => setIsLoading(null)
    }, [auth])
    return (
        auth.isAuthenticated || isLoading === true || isLoading === null ?
            <LoadingScreen message={t("core:pages.logout.spinner.message")} /> : <Error409 />
    );
};
